import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  StepIndicatorModel, StepIndicatorService, AccordionComponent, AccordionModel, CustomgridComponent, GridOptionsModel,
  ColumnDefinitionsModel, PaginationsModel, DatePickerService
} from 'lib/ng2-sapmp/src/ui-components';
import {
  EnrollmentDateModel, SignUpOutputModel, SignUpInputModel, FanModel, SettingsModel,
  AppModel
} from './../shared/models/signup.models';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { SignupService } from './../shared/providers/signup.service';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { MOBILEPIVOTS, SIGNUPDATA } from 'config';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  providers: [SignupService, DatePickerService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmComponent implements OnInit, OnDestroy {

  public profileId: string;
  public form: FormGroup;
  public customProfile = new FormControl('', Validators.required);
  public msg: any;
  public fanList: Array<FanModel>;
  public page: any;
  public createProfile: boolean;
  public showAppleCertificate: string;
  private signupOutputModel: SignUpOutputModel;
  private signupInputModel: SignUpInputModel;
  private initialSignup = false;
  public authenticatepage: boolean;
  public initModal: boolean;
  public confirmModalPopup: ConfirmModalPopupModel;
  public pageContent: any;
  public selectedFan: any;
  public backToCallingPage: string;
  pivots: Array<MobilePivotModel>;
  displayFANText: string;
  existingDateNull: boolean;
  changeEnrollmentSettings: boolean;
  public pageDescription: Array<any>;
  private activeFANList: Array<FanModel> = [];
  private futureEnrollList: Array<FanModel> = [];
  emmProductCode: any;
  prodFlag: boolean;
  OemHeading: any;
  selectedAccID: any;
  selectedSamsungID: any;
  selectedGoogleID: any;
  productSelection: String;
  mobileView: any;
  manageProduct: any;
  successHeading: string;
  successMessage: string;
  showOverviewModal: any;
  videoId: string;
  helpArticles: any;
  article: any;
  supportArticle = false;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private pageloaderService: PageLoaderService,
    private signupService: SignupService,
    private utilityService: UtilityService,
    private formBuilder: FormBuilder,
    private dateforamtter: DatePickerService,
    private adobeAnalyticsService: AdobeAnalyticsService) {
    this.existingDateNull = false;
    this.pageloaderService.setPageLoaderStatus(false);
    const signupModel = this.signupService.getSignupModel();
    let revisedFanList;

    if (signupModel) {
      this.signupOutputModel = signupModel.outputModel;
      this.signupInputModel = signupModel.inputModel;
      revisedFanList = this.signupOutputModel.FANList.revisedFanList;
      this.initialSignup = signupModel.initialSignup;
      this.createProfile = signupModel.isNewProfile;

      this.selectedFan = this.signupService.getSelectedFAN(this.signupOutputModel.FANList);
      this.fanList = this.signupOutputModel.FANList[this.selectedFan];
      this.displayFANText = this.fanList.length === 1 ? ' Foundation account selected' : ' Foundation accounts selected';
      this.authenticatepage = true;
    } else {
      this.authenticatepage = false;
      this.router.navigate(['signup']);
    }
    if (revisedFanList) {
      console.log(revisedFanList);
      revisedFanList.forEach(fan => {
        if (fan.accountSubStatus === 'Active') {
          this.activeFANList.push(fan);
        } else {
          this.futureEnrollList.push(fan);
        }
      });
    }

  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];

    if (!this.authenticatepage) {
      return;
    }
    this.mobileView = document.body.clientWidth < 1024;
    // this.emmProductCode = sessionStorage.getItem('emmProductCode');
    // this.selectedAccID = sessionStorage.getItem('selectedAccID');
    this.manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
    this.emmProductCode = this.manageProduct.emmProductCode;
    this.selectedAccID = this.manageProduct.selectedAccID;
    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
      this.prodFlag = true;
    } else {
      this.prodFlag = false;
    }

    this.productSelection = '/productselection';
    this.pageDescription = [{
      'header': 'Accounts with enrolled devices',
      'accordion': [this.createAccordionModelChange('ActiveFAN', 'hi')],
      'hide': !this.activeFANList.length,
      'gridHeader': (this.activeFANList.length === 1) ? this.activeFANList.length +
      '&ensp; ' + 'Account with deployed devices' : this.activeFANList.length + '&ensp; ' + 'Accounts with deployed devices',
      'gridOptions': this.createGridOptions('active'),
      'moreThanFiveFan': this.activeFANList.length > 5,
      'gridCallback': this.updateActiveList
    }, {
      'header': 'Accounts with pending devices',
      'accordion': [this.createAccordionModelChange('FutureFAN', 'hi')],
      'hide': !this.futureEnrollList.length,
      'gridHeader': (this.futureEnrollList.length === 1) ? this.futureEnrollList.length +
      '&ensp; ' + 'Account with devices not yet enrolled' : this.futureEnrollList.length +
      '&ensp; ' + 'Accounts with devices not yet enrolled',
      'gridOptions': this.createGridOptions('future'),
      'moreThanFiveFan': this.futureEnrollList.length > 5,
      'gridCallback': this.updateFutureList
  }];

    if (this.futureEnrollList.length > 0 || this.activeFANList.length > 0) {
      this.changeEnrollmentSettings = true;
    }else {
      this.changeEnrollmentSettings = false;
    }

    this.backToCallingPage = sessionStorage.getItem('SignupBacktoCallingPage');
    if (!this.backToCallingPage || this.backToCallingPage === '/home') {
      this.backToCallingPage = '/manageInventory';
    }
    this.pivots = MOBILEPIVOTS.SIGNUPPAGE;
    this.pivots[0].routerLink = this.backToCallingPage;
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    const settings: SettingsModel = this.signupOutputModel.profile.settings;
    const enrollmentDate: EnrollmentDateModel = this.signupOutputModel.deviceEnrollDate;
    if (enrollmentDate.existing == null || enrollmentDate.existing === undefined) {
      this.existingDateNull = true;
    }
    const applications = this.signupOutputModel.profile.applications;
    this.showAppleCertificate = '';

    this.signupService.getAppleSummary().subscribe(res => {
      this.showAppleCertificate = res.status;
    });

    this.signupService.pageContent(this.utilityService.getEnvConfig().contentUrl.signup.confirm).
      subscribe(respobj => {
        this.pageContent = respobj;

        this.pageContent.appleCertificate['Not Installed'].description = this.pageContent.appleCertificate['Not Installed']
          .description.split(/[[\]]/);
        this.pageContent.appleCertificate['Expired'].description = this.pageContent.appleCertificate['Expired'].description.split(/[[\]]/);

        this.msg = {
          id: 'success',
          class: 'icon-approval',
          header1: this.pageContent.successMsg.heading1,
          header2: this.pageContent.successMsg.heading2,
          description: this.pageContent.successMsg.description,
          oemHeader: this.pageContent.successMsg.oemHeader
        };

        this.form = this.formBuilder.group({
          'customProfile': this.customProfile
        });

        let notificationEnabled = -1;
        if (settings.emailEnabled && !settings.smsEnabled) {
          notificationEnabled = 0;
        } else if (!settings.emailEnabled && settings.smsEnabled) {
          notificationEnabled = 1;
        } else if (settings.emailEnabled && settings.smsEnabled) {
          notificationEnabled = 2;
        }

        this.page = {
          company: this.signupOutputModel.companyId,
          participationDate: this.dateforamtter.formatDate('mm/dd/yyyy', new Date()),
          fanList: {
            accordion: this.fanList.length > 5 ? [this.createAccordionModel('selectedFan')] : undefined,
            gridOptions: this.createGridOptions('selectedFan')
          },

          settings: [
            { key: this.pageContent.settings.newDevNwLabel + ' : ', value: settings.newDevNwt ? 'ON' : 'OFF' },
            { key: this.pageContent.settings.extDevNwlabel + ' : ', value: settings.extDevNwt ? 'ON' : 'OFF' },
            {
              key: this.pageContent.settings.securityPolicy + ' : ',
              value: SIGNUPDATA.SettingsPage.securityPolicy[settings.securityPolicy]
            },
            {
              key: this.pageContent.settings.passcodePolicy + ' : ',
              value: SIGNUPDATA.SettingsPage.passcodePolicy[settings.passCodePolicy]
            },
            {
              key: 'Send notifications by:', value: notificationEnabled === -1 ? '' : this.pageContent.settings.notification[notificationEnabled]
            }
          ],
          settingsOem: [
            {
              key: 'Send notifications by:', value: notificationEnabled === -1 ? '' : this.pageContent.settings.notification[notificationEnabled]
            }
          ],
          applications: this.signupService.selectedAppList(this.signupInputModel.appList,
            this.signupOutputModel.profile.applications),
          enrollmentDate: [
            {
              key: this.pageContent.enrollDate.new + ' : ', value: this.dateforamtter.
                formatDate('mm/dd/yyyy', new Date(enrollmentDate.new))
            },
            {
              key: this.pageContent.enrollDate.existing + ' : ', value: this.dateforamtter.
                formatDate('mm/dd/yyyy', new Date(enrollmentDate.existing))
            }
          ],
          formInput: {
            heading: this.signupOutputModel.profile.defaultProfile ? this.pageContent.newProfile.heading :
              this.pageContent.revisedProfile.heading,
            description: this.signupOutputModel.profile.defaultProfile ?
              this.pageContent.newProfile.description.replace('<profileId>', this.signupOutputModel.profile.profileName) :
              this.pageContent.revisedProfile.description.replace('<profileId>', this.signupOutputModel.profile.profileName)
          }
        };

        this.pageloaderService.setPageLoaderStatus(true);
        this.signupService.removeSignupModel();

        if (this.emmProductCode === 'DMPGZTP') {
          this.OemHeading = this.pageContent.MDMService.googleLabel;
          this.selectedGoogleID = this.selectedAccID;
          this.successHeading = this.pageContent.successMsg.zteHeading;
          this.successMessage = this.pageContent.successMsg.zteMsg;
        }else if (this.emmProductCode === 'DMPSKME') {
          this.OemHeading = this.pageContent.MDMService.samsungLabel;
          this.selectedSamsungID = this.selectedAccID;
          this.successHeading = this.pageContent.successMsg.zteHeading;
          this.successMessage = this.pageContent.successMsg.zteMsg;
        }else {
          this.OemHeading = this.pageContent.MDMService.ibmLabel;
          this.successHeading = this.pageContent.successMsg.ibmHeading;
          this.successMessage = this.pageContent.successMsg.ibmMsg;
        }

      });
      this.helpArticles = [{ id: 1, isActive: true, category: 'Help', content: '' }];
      const pageName = 'signupConfirmPage';
      if (!this.prodFlag) {
        this.signupService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument + pageName).
          subscribe(resp => {
            this.article = resp.supportArticles;
            this.article.name = this.article.availableArticle[0].name;
            this.article.url = this.article.availableArticle[0].url;
            this.supportArticle = true;
          }, (err) => {
           // this.handleError(err);
          });
      }      this.signupService.createPageLoadProperties('CONFIRM', 'Confirm');
  }

  backToProductSelection() {
    event.preventDefault();
    this.router.navigate(['/productselection/']);
  }

  createAccordionModel(id: string) {
    const accordionModel = new AccordionModel();
    accordionModel.id = id;
    accordionModel.isActive = false;
    accordionModel.category = ' Selected foundation accounts';
    accordionModel.ariaLabel = this.pageContent.accordionAriaLabel;
    return accordionModel;
  }
  createAccordionModelChange(id: string, ariaLabel) {
    const accordionModel = new AccordionModel();
    const fanList = (id === 'ActiveFAN') ? this.activeFANList : this.futureEnrollList;
    accordionModel.id = id;
    accordionModel.isActive = false;
    accordionModel.category = (id === 'ActiveFAN') ? (this.activeFANList.length + '&ensp; ' + '  Accounts with deployed devices')
      : (this.futureEnrollList.length + '&ensp; ' + '  Accounts with devices not yet enrolled');
    accordionModel.ariaLabel = ariaLabel;
    return accordionModel;
  }
  updateFutureList = ($event: any) => {
    this.futureEnrollList = $event.griddata;
    const title = (this.filterSelected(this.futureEnrollList).length === 1) ?
    this.filterSelected(this.futureEnrollList).length + ' Foundation Account Selected' :
    this.filterSelected(this.futureEnrollList).length + ' Foundation Accounts Selected';
    this.updateView(this.pageDescription[1], title);
  }

  updateActiveList = ($event: any) => {
    this.activeFANList = $event.griddata;
    const title = (this.filterSelected(this.activeFANList).length === 1) ?
    this.filterSelected(this.activeFANList).length + ' Foundation Account Selected' :
    this.filterSelected(this.activeFANList).length + ' Foundation Accounts Selected';
    this.updateView(this.pageDescription[0], title);
  }

  updateView(description: any, title: string) {
    if (description.accordion) {
      description.accordion[0].category = title;
    } else {
      description.gridHeader = title;
    }
  }

  filterSelected(fanList: Array<any>) {
    const filteredFans = new Array();
    fanList.forEach(fan => {
      if (fan.selected) {
        filteredFans.push(fan);
      }
    });
    return filteredFans;
  }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === 'url') {
      this.initPopupModal(articleNumber);
    }
  }

  initPopupModal(articleNumber) {
    this.videoId = this.article.availableArticle[articleNumber].url;
    this.showOverviewModal = true;
  }

  closeOverviewModal() {
    this.showOverviewModal = false;

  } 
   createGridOptions(id: string) {
    const gridOption = new GridOptionsModel();
    const columns: ColumnDefinitionsModel = {
      field: 'fanId',
      caption: 'Foundation Accounts',
      type: 'TEXT'
    };

    const pages: PaginationsModel = {
      recordsPerPage: 20,
      currentPage: 1,
      totalRecords: this.fanList.length,
      isServerSide: false,
    };

    gridOption.enableFiltering = false;
    gridOption.columnDefinitions = [columns];
    gridOption.enableSorting = false;
    gridOption.Paginations = pages;
    gridOption.searchPlaceHolder = '';
    gridOption.searchDescriptions = '';
    gridOption.callbacks = null;
    gridOption.multiSelect = false;
    gridOption.disableGrid = false;
    gridOption.disableRow = false;
    gridOption.showPaginationIndex = this.fanList.length > 5;

    if (this.selectedFan === 'revisedFanList') {
      gridOption.columnDefinitions.push({
        caption: 'Set up Status', field: 'accountStatus', type: 'TEXT'
      });
      gridOption.gridData = id === 'active' ? this.activeFANList : this.futureEnrollList;
      gridOption.gridData = gridOption.gridData.map(item => {
        item.accountStatus = 'Processing';
        return item;
      });
    } else {
      gridOption.gridData = this.fanList;
    }

    return gridOption;

  }

  closeModal(confirm) {
    this.initModal = false;
  }

  onSubmit() {
    this.msg.show = false;
    this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formSubmit',
    'BC_Device_Signup_Profilename_Submit', 'success', 'Success_Admit', 'Save', 'Body', '/businessconsole/signup/confirm');
    this.pageloaderService.setPageLoaderStatus(false);
    if (this.customProfile) {
      if (this.signupInputModel.profileList.filter(item => item.profileName === this.customProfile.value).length === 0) {
        this.msg = { id: '' };

        if (!this.utilityService.getEnvConfig().useMock) {
          console.log('Profile name Update API request time => ' + new Date().getTime());
          this.signupService.updateProfileName(this.signupOutputModel.profile.profileId, this.customProfile.value)
            .subscribe(resobj => {
              console.log('Profile name Update API response time => ' + new Date().getTime());
              this.msg = {
                id: 'updated',
                class: 'icon-success',
                header: 'Success',
                description: resobj.status
              };
              this.page.formInput.description = this.customProfile.value ?
              this.pageContent.newProfile.description.replace('<profileId>', this.customProfile.value) :
              this.pageContent.revisedProfile.description.replace('<profileId>', this.customProfile.value);

              // Adobe Analytics Starts
              this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
              'BC_Device_Signup_Profilename_Submit', 'success', 'Success_Admit', 'Save', 'Body', '/businessconsole/signup/confirm');
              // Ends
              this.pageloaderService.setPageLoaderStatus(true);
            }, (error) => {
              this.msg = {
                id: 'error',
                class: 'icon-badgealert',
                header: 'We have entered the following system error.',
                description: 'Please choose a different name, the one you have already exists'
              };
              this.pageloaderService.setPageLoaderStatus(true);
              // Adobe Analytics Starts
              this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
              'BC_Device_Signup_Profilename_Submit', 'Please choose a different name, the one you have already exists',
              'Failure_user', 'Save', 'Body', '/businessconsole/signup/confirm');
              // Ends
            });
        } else {
          this.msg = {
            id: 'updated',
            class: 'icon-success',
            header: 'Success',
            description: 'Profile name updated.'
          };
          this.page.formInput.description = this.customProfile.value ?
              this.pageContent.newProfile.description.replace('<profileId>', this.customProfile.value) :
              this.pageContent.revisedProfile.description.replace('<profileId>', this.customProfile.value);

          this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
          'BC_Device_Signup_Profilename_Submit', 'success', 'Success_Admit', 'Save', 'Body', '/businessconsole/signup/confirm');
          this.pageloaderService.setPageLoaderStatus(true);
        }
      } else {
        this.msg = {
          id: 'error',
          class: 'icon-badgealert',
          header: 'We have entered the following system error.',
          description: 'Please choose a different name, the one you have already exists'
        };
        this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
        'device_signup_profilename_submit', 'Please choose a different name, the one you have already exists',
        'Failure_user', 'save', 'Body', '/businessconsole/signup/confirm');
        this.pageloaderService.setPageLoaderStatus(true);
      }
    }
  }

  ngOnDestroy() {
  }
}
